/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {Component} from '@angular/core';

import {AbstractField} from './abstract-field';

/**
 * An table type field which is using handsontable
 */
@Component({
  selector: 'gp-form-field-table',
  template: `
    <table-input [formControl]="control"
                 [(ngModel)]="value.value"
                 [attr.test-id]="descriptor.zoneID"
                 [readOnly]="readOnly"
                 [startDate]="descriptor?.metadatas?.startDate"
                 [endDate]="descriptor?.metadatas?.endDate"
                 [typeOfItems]="descriptor?.metadatas?.typeOfItems"
                 class="direction-ltr">
    </table-input>
  `
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableFieldComponent extends AbstractField {
}
